package pt.at.oss.kotlin.manual.schema.common.bankaccountinfo

import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.BANK_ACCOUNT_BIC_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.BANK_ACCOUNT_IBAN_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.BANK_ACCOUNT_OBAN_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.BANK_ACCOUNT_OWNER_MAX_LEN
import pt.at.oss.kotlin.manual.storage.common.bankaccountinfo.BankAccountInfo
import pt.lightweightform.kotlin.schema.RecordSchema
import pt.lightweightform.kotlin.schema.StringSchema
import pt.lightweightform.kotlin.type.validator.ValidationErrors
import pt.lightweightform.kotlin.util.appendToPath

/**
 * BankAccountInfoSchema Schema object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
class BankAccountInfoSchema : RecordSchema<BankAccountInfo>(name = "bankAccountInfo") {

    val ibanSchema: StringSchema = StringSchema(name = "iban", maxLength = BANK_ACCOUNT_IBAN_MAX_LEN)
    val obanSchema: StringSchema = StringSchema(name = "oban", maxLength = BANK_ACCOUNT_OBAN_MAX_LEN)
    val bicSchema: StringSchema = StringSchema(name = "bic", minLength = 1, maxLength = BANK_ACCOUNT_BIC_MAX_LEN)
    val accountHolderSchema: StringSchema = StringSchema(name = "accountHolder", minLength = 1, maxLength = BANK_ACCOUNT_OWNER_MAX_LEN)
    override fun isValid(value: BankAccountInfo?): Boolean {
        return value == null || (
            ibanSchema.isValid(value.iban) &&
                obanSchema.isValid(value.iban) &&
                bicSchema.isValid(value.bic) &&
                accountHolderSchema.isValid(value.accountHolder)
            )
    }

    override fun validate(value: BankAccountInfo?, path: String): ValidationErrors {
        val validator = super.validate(value, path)
        if (value === null) {
            return validator
        }
        validator.addErrors(ibanSchema.validate(value.iban, appendToPath(path, "iban")))
        validator.addErrors(obanSchema.validate(value.iban, appendToPath(path, "iban")))
        validator.addErrors(bicSchema.validate(value.bic, appendToPath(path, "bic")))
        validator.addErrors(accountHolderSchema.validate(value.accountHolder, appendToPath(path, "accountHolder")))
        return validator
    }
}
